module.exports = __webpack_public_path__ + "img/cib.a0ad4531.jpg";